module.exports = __webpack_public_path__ + "img/credit-cards.7f89b025.png";